import { apiClient } from './apiClient';

export interface AnalyticsEvent {
    id: string;
    linkId: string;
    eventType: string;
    target?: string;
    date: string;
    device?: string;
    country?: string;
    count: number;
}

export interface AnalyticsSummary {
    totalViews: number;
    totalClicks: number;
    byEventType: Record<string, number>;
    byCountry: Record<string, number>;
    byDevice: Record<string, number>;
}

export const analyticsApi = {
    async getAnalyticsByLinkId(
        linkId: string,
        startDate?: string,
        endDate?: string
    ): Promise<AnalyticsEvent[]> {
        let url = `/api/analytics/link/${linkId}`;
        const params = new URLSearchParams();

        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);

        if (params.toString()) {
            url += `?${params.toString()}`;
        }

        const response = await apiClient.get<{ success: boolean; data: AnalyticsEvent[] }>(url);
        return response.data;
    },

    async getAnalyticsSummary(
        linkId: string,
        startDate?: string,
        endDate?: string
    ): Promise<AnalyticsSummary> {
        let url = `/api/analytics/link/${linkId}/summary`;
        const params = new URLSearchParams();

        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);

        if (params.toString()) {
            url += `?${params.toString()}`;
        }

        const response = await apiClient.get<{ success: boolean; data: AnalyticsSummary }>(url);
        return response.data;
    }
};

